export default __webpack_public_path__ + "static/media/biology.0887afb5.svg";